/**
 * 录音分享
 */
import $share from '@/api/modules/share'
import { AsyncRequest } from '@/utils/request'

const state = {
  soundRecordShareInfo: {}
}

const getters = {
  recordInfo: state => {
    return state.soundRecordShareInfo
  }
}

const mutations = {
  setSoundRecordShareInfo: (state, info) => {
    state.soundRecordShareInfo = info
  }
}

const actions = {
  // 获取录音分享
  getSoundRecordShareInfo({ commit }, payload) {
    return AsyncRequest({
      loading: true,
      request: () => $share.getSoundRecordShareInfo(payload),
      resolve: (info) => commit('setSoundRecordShareInfo', info)
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
